import InputDate, { InputDateProps } from "components/inputDate"
import DatePicker from "components/datePicker"
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "store/store"

interface DateInputProps extends InputDateProps {
  preferences: any
}

const DateInput = ({
  preferences,
  className,
  modalZIndex,
  calenderHeader,
  placeholder,
  value,
  minDate,
  maxDate,
  onChange,
  tileDisabled,
}: DateInputProps) => {
  return (
    <>
      {preferences.isMobile ? (
        <InputDate
          modalZIndex={modalZIndex}
          className={className}
          calenderHeader={calenderHeader}
          placeholder={placeholder}
          minDate={minDate}
          maxDate={maxDate}
          tileDisabled={tileDisabled}
          value={value}
          onChange={onChange}
          />
      ) : (
        <DatePicker
          className={className}
          calenderHeader={calenderHeader}
          placeholder={placeholder}
          minDate={minDate}
          maxDate={maxDate}
          tileDisabled={tileDisabled}
          value={value}
          onChange={onChange}
        />
      )}
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(DateInput)
